/**
 * Current CSRF token for hand-rolled requests (fetch, axios, plain forms).
 *
 * inertia_rails writes a fresh token into the readable XSRF-TOKEN cookie on
 * every response, which is what Inertia's own requests send. The
 * <meta name="csrf-token"> tag is rendered once at document load and goes stale
 * whenever the session changes underneath the page — a sign-in or sign-out in
 * another tab, a server restart — after which Rails answers 422 even though the
 * Inertia forms on the same page still work. Prefer the cookie; keep the meta
 * tag as the fallback for documents rendered without it.
 */
export function csrfToken(): string | null {
  if (typeof document === 'undefined') return null

  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/)
  if (match?.[1]) {
    try {
      return decodeURIComponent(match[1])
    } catch {
      // Malformed cookie value; fall through to the meta tag.
    }
  }

  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
  return meta?.content || null
}
